import { FC } from 'react';

import { BackgroundTint, FallingLeaves, FlyingGhosts } from './fall';
import { useSeasonalTheme } from './seasonal-theme-context';

/**
 * Seasonal Effects Component
 * Renders non-intrusive seasonal animations and effects when the theme is enabled
 */
export const SeasonalEffects: FC = () => {
	const { isSeasonalThemeEnabled } = useSeasonalTheme();

	if (!isSeasonalThemeEnabled) {
		return null;
	}

	return (
		<>
			<BackgroundTint />
			<FallingLeaves />
			<FlyingGhosts />
		</>
	);
};
